import React from 'react';
import { Download, FileText, PieChart, Briefcase } from 'lucide-react';

const ExportReports = ({ data, calculations, scenarios }) => {
  const generateCashFlowReport = () => {
    // Generate comprehensive cash flow report
    const reportData = {
      date: new Date()?.toLocaleDateString(),
      ...data,
      ...calculations,
      scenarios: scenarios?.map(s => ({
        name: s?.name,
        results: s?.results
      }))
    };

    const blob = new Blob([JSON.stringify(reportData, null, 2)], { type: 'application/json' });
    const url = URL?.createObjectURL(blob);
    const a = document?.createElement('a');
    a.href = url;
    a.download = `cash-flow-report-${Date?.now()}.json`;
    a?.click();
    URL?.revokeObjectURL(url);
  };

  const generateInvestorPresentation = () => {
    // Generate investor presentation format
    alert('Investor presentation generation coming soon!');
  };

  const generateOperationalPlan = () => {
    // Generate operational planning document
    alert('Operational planning document generation coming soon!');
  };

  const exportOptions = [
    {
      icon: FileText,
      title: 'Cash Flow Report',
      description: 'Detailed financial projections',
      action: generateCashFlowReport,
      colorClass: 'blue'
    },
    {
      icon: PieChart,
      title: 'Investor Presentation',
      description: 'Executive summary & metrics',
      action: generateInvestorPresentation,
      colorClass: 'purple'
    },
    {
      icon: Briefcase,
      title: 'Operational Plan',
      description: 'Planning documents',
      action: generateOperationalPlan,
      colorClass: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: {
        bg: 'bg-blue-50',
        hoverBg: 'hover:bg-blue-100',
        border: 'border-blue-200',
        iconBg: 'bg-blue-100',
        iconText: 'text-blue-600',
        titleText: 'text-blue-900',
        descText: 'text-blue-700'
      },
      purple: {
        bg: 'bg-purple-50',
        hoverBg: 'hover:bg-purple-100',
        border: 'border-purple-200',
        iconBg: 'bg-purple-100',
        iconText: 'text-purple-600',
        titleText: 'text-purple-900',
        descText: 'text-purple-700'
      },
      green: {
        bg: 'bg-green-50',
        hoverBg: 'hover:bg-green-100',
        border: 'border-green-200',
        iconBg: 'bg-green-100',
        iconText: 'text-green-600',
        titleText: 'text-green-900',
        descText: 'text-green-700'
      }
    };
    return colorMap?.[color];
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
          <Download className="w-5 h-5 text-slate-600" />
        </div>
        <h3 className="text-sm font-bold text-slate-900">Export Reports</h3>
      </div>

      <div className="space-y-3">
        {exportOptions?.map((option, index) => {
          const OptionIcon = option?.icon;
          const colors = getColorClasses(option?.colorClass);
          
          return (
            <button
              key={index}
              onClick={option?.action}
              className={`w-full p-4 ${colors?.bg} ${colors?.hoverBg} rounded-lg border ${colors?.border} transition-colors text-left`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-lg ${colors?.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <OptionIcon className={`w-4 h-4 ${colors?.iconText}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className={`text-sm font-medium ${colors?.titleText} mb-0.5`}>
                    {option?.title}
                  </p>
                  <p className={`text-xs ${colors?.descText}`}>
                    {option?.description}
                  </p>
                </div>
                <Download className={`w-4 h-4 ${colors?.iconText} flex-shrink-0`} />
              </div>
            </button>
          );
        })}
      </div>

      <div className="mt-4 pt-4 border-t border-slate-200">
        <p className="text-xs text-slate-600 text-center">
          Reports include executive summaries and professional formatting
        </p>
      </div>
    </div>
  );
};

export default ExportReports;